import {
  LayoutDashboard, Factory, ShoppingCart, Package, Warehouse,
  FlaskConical, Landmark, Calculator, Network, Bot, Users, Truck, Mic, ClipboardList, Gauge, FileText, KeyRound, Route, Radio, FileUp, Store, CalendarCheck, Printer, CalendarClock, Recycle, PackageSearch, ShoppingBag, Headset,
} from "lucide-react";

// Module registry. `roles` = who can access. Admin sees everything.
export const MODULES = [
  { key: "dashboard", label: "Command Center", short: "HOME", path: "/", icon: LayoutDashboard,
    color: "#0a6ed1", roles: ["plant_mgr", "controller", "warehouse_dir", "qc_inspector", "sales_exec"] },
  { key: "md", label: "MD Summary", short: "EXEC", path: "/executive", icon: Gauge,
    color: "#D0313A", roles: ["controller"] },
  { key: "pp", label: "Production Planning", short: "PP", path: "/production", icon: Factory,
    color: "#3B82F6", roles: ["plant_mgr", "qc_inspector"] },
  { key: "sd", label: "Sales & Distribution", short: "SD", path: "/sales", icon: ShoppingCart,
    color: "#8B5CF6", roles: ["controller", "sales_exec"] },
  { key: "order_import", label: "Order File Import", short: "IMP", path: "/order-import", icon: FileUp,
    color: "#0f766e", roles: ["controller", "sales_exec", "warehouse_dir"] },
  { key: "store_directory", label: "M&S Store Directory", short: "DIR", path: "/store-directory", icon: Store,
    color: "#0f766e", roles: ["controller", "sales_exec", "warehouse_dir"] },
  { key: "pim", label: "eCommerce PIM", short: "PIM", path: "/pim", icon: PackageSearch,
    color: "#7c3aed", roles: ["controller", "sales_exec"] },
  { key: "support_inbox", label: "Webshop Live Chat", short: "CHAT", path: "/support-inbox", icon: Headset,
    color: "#F06600", roles: ["controller", "sales_exec", "warehouse_dir"] },
  { key: "quotations", label: "Quotations", short: "QT", path: "/quotations", icon: FileText,
    color: "#8B5CF6", roles: ["controller", "sales_exec"] },
  { key: "fr_einv", label: "E-Invoicing", short: "E-INV", path: "/einvoicing", icon: FileText,
    color: "#0055A4", roles: ["controller", "sales_exec"] },
  { key: "eudr", label: "EUDR Compliance", short: "EUDR", path: "/eudr", icon: FileText,
    color: "#1a7f37", roles: ["controller", "warehouse_dir"] },
  { key: "waste", label: "Waste & Compliance", short: "WASTE", path: "/waste-compliance", icon: Recycle,
    color: "#1a7f37", roles: ["controller", "warehouse_dir", "plant_mgr", "qc_inspector"] },
  { key: "us_tax", label: "US Sales Tax", short: "US-TAX", path: "/us-tax", icon: FileText,
    color: "#B10DC9", roles: ["controller"] },
  { key: "customers", label: "Business Partners", short: "BP", path: "/customers", icon: Users,
    color: "#7c3aed", roles: ["controller", "sales_exec"] },
  { key: "delivery", label: "Outbound Deliveries", short: "OBD", path: "/deliveries", icon: Truck,
    color: "#0EA5E9", roles: ["sales_exec", "warehouse_dir"] },
  { key: "transport", label: "Delivery Planning & POD", short: "POD", path: "/transport", icon: Route,
    color: "#0284C7", roles: ["warehouse_dir", "sales_exec"] },
  { key: "scheduling", label: "Delivery Scheduling", short: "SCHED", path: "/scheduling", icon: CalendarClock,
    color: "#4F46E5", roles: ["warehouse_dir", "sales_exec", "controller", "plant_mgr"] },
  { key: "whmonitor", label: "Warehouse Live Monitor", short: "LIVE", path: "/warehouse-monitor", icon: Radio,
    color: "#0f766e", roles: ["warehouse_dir", "plant_mgr"] },
  { key: "driver", label: "My Deliveries", short: "DRIVE", path: "/driver", icon: Truck,
    color: "#0EA5E9", roles: ["driver"] },
  { key: "mm", label: "Materials Management", short: "MM", path: "/materials", icon: Package,
    color: "#F97316", roles: ["warehouse_dir"] },
  { key: "purchasing", label: "Purchasing", short: "PUR", path: "/purchasing", icon: ClipboardList,
    color: "#0D9488", roles: ["warehouse_dir", "plant_mgr"] },
  { key: "ewm", label: "Warehouse & ASRS", short: "EWM", path: "/warehouse", icon: Warehouse,
    color: "#EC4899", roles: ["plant_mgr", "warehouse_dir"] },
  { key: "picking", label: "Voice Picking", short: "PICK", path: "/picking", icon: Mic,
    color: "#DB2777", roles: ["plant_mgr", "warehouse_dir", "picker"] },
  { key: "pick_conf", label: "Pick Confirmations", short: "PCONF", path: "/pick-confirmations", icon: ClipboardList,
    color: "#DB2777", roles: ["plant_mgr", "warehouse_dir", "controller"] },
  { key: "print_center", label: "Print Centre", short: "PRINT", path: "/print-center", icon: Printer,
    color: "#0f766e", roles: ["warehouse_dir", "plant_mgr", "controller", "sales_exec"] },
  { key: "qm", label: "Quality Management", short: "QM", path: "/quality", icon: FlaskConical,
    color: "#EAB308", roles: ["plant_mgr", "qc_inspector"] },
  { key: "fi", label: "Financial Accounting", short: "FI", path: "/finance", icon: Landmark,
    color: "#10B981", roles: ["controller"] },
  { key: "month_end", label: "Month-End Close", short: "CLOSE", path: "/month-end", icon: CalendarCheck,
    color: "#10B981", roles: ["controller"] },
  { key: "co", label: "Controlling", short: "CO", path: "/controlling", icon: Calculator,
    color: "#06B6D4", roles: ["controller"] },
  { key: "edi", label: "EDI Gateway", short: "EDI", path: "/edi", icon: Network,
    color: "#0284C7", roles: ["sales_exec", "warehouse_dir"] },
  { key: "ai", label: "AI Copilot", short: "AI", path: "/copilot", icon: Bot,
    color: "#A855F7", roles: ["plant_mgr", "controller", "warehouse_dir", "qc_inspector", "sales_exec"] },
  { key: "tcodes", label: "Transaction Codes", short: "TCODE", path: "/transaction-codes", icon: KeyRound,
    color: "#354a5f", roles: ["plant_mgr", "controller", "warehouse_dir", "qc_inspector", "sales_exec"] },
];

export function modulesForRole(role) {
  if (role === "admin") return MODULES;
  return MODULES.filter((m) => m.roles.includes(role));
}

// Role-specific landing route (field roles skip the Command Center).
const ROLE_HOME = { driver: "/driver", picker: "/picking", ms_buyer: "/shop" };
export function homeForRole(role) {
  return ROLE_HOME[role] || "/";
}
